import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Input,
  Dropdown,
  Icon,
  Checkbox,
  Button,
  Label
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardSettingPackageUX = (props: any) => {
    return(
      <div
        style={{width: "100%"}}>
        <div
          style={{display: "flex", alignItems: "center", justifyContent: "space-between", padding: "15px 10px", backgroundColor: "#A5D9FF"}}>
          
          <div
            style={{fontSize: "1.15rem", fontWeight: "bold"}}>
            {props.languageUX === "en" ? "Package details settings" : "การตั้งค่ารายละเอียดแพ็กเกจ"}
          </div>
        </div>
        <div
          className="ui divider"
          style={{marginTop: 0}}>
          
        </div>
        <div>
          {props.SubSearchPackage}
        </div>
        <div
          className={`ui form ${props.isActive  ? "--override-disabled": ""}`}
          style={{padding: "0 20px", display: !props.hideDetail ? "": "none"}}>
          
          <FormGroup>
            <FormField
              style={{fontWeight: "bold", fontSize: "1.2rem", borderBottom: "1px solid rgba(34,36,38,.15)", padding: "0px 0px 0.55rem 0.5rem"}}
              width={16}>
              <div>
                {props.packageDetail?.id?`${props.packageDetail?.code} : ${props.packageDetail?.name}`:"เพิ่มรายการใหม่"}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            inline={true}>
            <FormField
              inline={true}>
              <div
                style={{display: "flex", alignItems: "center", width: "200px"}}>
                
                <label
                  style={{fontWeight: "bold", marginRight: "5px"}}>
                  {props.languageUX === "en" ? "Code" : "รหัส"}
                </label>
                <label>
                  {props.languageUX === "en" ? "Package code" : "รหัสแพ็กเกจ"}
                </label>
                <label
                  style={{color: "red"}}>
                  *
                </label>
              </div>
            </FormField>
            <FormField
              className={!!props.showRequiredField?.code ? "error" : ""}
              inline={true}
              width={4}>
              <Input
                disabled={props.isActive || false}
                id="CardSettingPackage-Input-Code"
                name="code"
                onChange={props.onChangeValue}
                value={props.packageDetail?.code || ""}>
              </Input>
            </FormField>
            <FormField
              style={{flex:1}}>
            </FormField>
            <FormField>
              <Label
                color={props.labelActive?.color}
                style={{display: props.labelActive?.text?"":"none", width: "100px", textAlign: "center"}}>
                {props.labelActive?.text}
              </Label>
            </FormField>
          </FormGroup>
          <FormGroup
            inline={true}>
            <FormField
              inline={true}>
              <div
                style={{display: "flex", alignItems: "center", width: "200px"}}>
                {}
                <label
                  style={{fontWeight: "bold", marginRight: "5px"}}>
                  {props.languageUX === "en" ? "Package name" : "ชื่อแพ็คเกจ"}
                </label>
                <label>
                  {props.languageUX === "en" ? "Package name" : "ชื่อแพ็กเกจ"}
                </label>
                <label
                  style={{color: "red"}}>
                  *
                </label>
              </div>
            </FormField>
            <FormField
              className={!!props.showRequiredField?.name ? "error" : ""}
              inline={true}
              width={6}>
              <Input
                disabled={props.isActive || false}
                id="CardSettingPackage-Input-PackageName"
                name="name"
                onChange={props.onChangeValue}
                value={props.packageDetail?.name|| ""}>
              </Input>
            </FormField>
          </FormGroup>
          <FormGroup>
            <FormField
              inline={true}>
              <div
                style={{display: "flex", alignItems: "center", width: "200px", marginTop: "0.75rem"}}>
                {}
                <label
                  style={{fontWeight: "bold", marginRight: "5px"}}>
                  {props.languageUX === "en" ? "Package type" : "ประเภทแพ็คเกจ"}
                </label>
                <label>
                  {props.languageUX === "en" ? "Package Type" : "ชนิดแพ็กเกจ"}
                </label>
                <label
                  style={{color: "red"}}>
                  *
                </label>
              </div>
            </FormField>
            <FormField
              className={!!props.showRequiredField?.package_type ? "error" : ""}
              inline={true}
              width={4}>
              <div
                style={{display: "flex",  alignItems: "baseline",}}>
                
                <Dropdown
                  clearable={true}
                  disabled={props.isActive || false}
                  id="CardSettingPackage-Dropdown-PackageType"
                  name="package_type"
                  onChange={props.onChangeValue}
                  options={props.packageTypeOptions || []}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.packageDetail?.package_type || ""}>
                </Dropdown>
                <div
                  style={{width: "fit-content", display: "flex", margin: "auto -7rem auto 1rem",cursor: "pointer", pointerEvents: props.isActive? "none": ""}}>
                  
                  <Icon
                    className="teal"
                    link={true}
                    name="plus"
                    onClick={()=> props.onOpenAdmin?.("PACKAGE_TYPE")}>
                  </Icon>
                  <div
                    style={{marginLeft: "0.75rem"}}>
                    {props.PackageRefreshIcon}
                  </div>
                </div>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            inline={true}>
            <FormField
              inline={true}>
              <div
                style={{display: "flex", alignItems: "center", width: "200px"}}>
                
                <label
                  style={{fontWeight: "bold", marginRight: "5px"}}>
                  {props.languageUX === "en" ? "Service type" : "ประเภทบริการ"}
                </label>
                <label>
                  {props.languageUX === "en" ? "Service type" : "ประเภทบริการ"}
                </label>
                <label
                  style={{color: "red"}}>
                  *
                </label>
              </div>
            </FormField>
            <FormField
              className={!!props.showRequiredField?.package_service_type ? "error" : ""}
              inline={true}
              style={{paddingRight: "0.75em"}}
              width={4}>
              <div
                style={{display: "flex",  alignItems: "baseline",width: "100%"}}>
                
                <Dropdown
                  clearable={true}
                  disabled={props.isActive || false}
                  id="CardSettingPackage-Dropdown-ServiceType"
                  name="package_service_type"
                  onChange={props.onChangeValue}
                  options={props.serviceTypeOptions || []}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.packageDetail?.package_service_type || ""}>
                </Dropdown>
                <div
                  style={{width: "fit-content", display: "flex", margin: "auto -7rem auto 1rem",cursor: "pointer", pointerEvents: props.isActive? "none": ""}}>
                  
                  <Icon
                    className="teal"
                    link={true}
                    name="plus"
                    onClick={()=> props.onOpenAdmin?.("SERVICE_TYPE")}>
                  </Icon>
                  <div
                    style={{marginLeft: "0.75rem"}}>
                    {props.ServiceRefreshIcon}
                  </div>
                </div>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            inline={true}>
            <FormField
              inline={true}>
              <div
                style={{display: "flex", alignItems: "center", width: "200px"}}>
                
                <label
                  style={{fontWeight: "bold", marginRight: "5px"}}>
                  {props.languageUX === "en" ? "Gender:" : "เพศ:"}
                </label>
              </div>
            </FormField>
            <FormField
              className={!!props.showRequiredField?.gender ? "error" : ""}
              inline={true}
              width={2}>
              <Dropdown
                disabled={props.isActive || false}
                fluid={true}
                id="CardSettingPackage-Dropdown-Gender"
                name="gender"
                onChange={props.onChangeValue}
                options={props.genderOptions || []}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.packageDetail?.gender || ""}>
              </Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup
            inline={true}>
            <FormField
              inline={true}>
              <div
                style={{display: "flex", alignItems: "center", width: "200px"}}>
                
                <label
                  style={{fontWeight: "bold", marginRight: "5px"}}>
                  {props.languageUX === "en" ? "Age start" : "อายุเริ่มต้น"}
                </label>
                <label>
                  {props.languageUX === "en" ? "Age (years)" : "อายุ (ปี)"}
                </label>
                <label
                  style={{color: "red"}}>
                  
                </label>
              </div>
            </FormField>
            <FormField
              inline={true}
              width={2}>
              <Input
                disabled={props.isActive || false}
                fluid={true}
                id="CardSettingPackage-Input-AgeStart"
                name="age_limits_year_start"
                onChange={props.onChangeValue}
                onKeyDown={(e: any)=> ["-","e"].includes(e.key) && e.preventDefault()}
                style={{width: "100%"}}
                type="number"
                value={props.packageDetail?.age_limits_year_start ?? ""}>
              </Input>
            </FormField>
            <FormField
              inline={true}
              width={2}>
              <div
                style={{display: "flex", alignItems: "center", justifyContent: "flex-end", width: "100%"}}>
                
                <label
                  style={{fontWeight: "bold", marginRight: "5px"}}>
                  {props.languageUX === "en" ? "Age end" : "สิ้นสุดอายุ"}
                </label>
                <label>
                  {props.languageUX === "en" ? "Age (years)" : "อายุ (ปี)"}
                </label>
              </div>
            </FormField>
            <FormField
              inline={true}
              width={2}>
              <Input
                disabled={props.isActive || false}
                fluid={true}
                id="CardSettingPackage-Input-AgeEnd"
                name="age_limits_year_end"
                onChange={props.onChangeValue}
                onKeyDown={(e: any)=> ["-","e"].includes(e.key) && e.preventDefault()}
                style={{width: "100%"}}
                type="number"
                value={props.packageDetail?.age_limits_year_end ?? ""}>
              </Input>
            </FormField>
            <FormField
              style={{display: props.showAgeError ? "": "none"}}>
              <label
                style={{color: "red", fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Age end must not be less than Age start" : "Age end ต้องไม่น้อยกว่า Age start"}
              </label>
            </FormField>
          </FormGroup>
          <FormGroup
            inline={true}>
            <FormField
              inline={true}>
              <div
                style={{display: "flex", alignItems: "center", width: "200px"}}>
                
                <label
                  style={{fontWeight: "bold",}}>
                  {props.languageUX === "en" ? "Start date" : "วันที่เริ่มต้น"}
                </label>
                <label
                  style={{color: "red"}}>
                  *
                </label>
              </div>
            </FormField>
            <FormField
              className={!!props.showRequiredField?.start_date? "error" : ""}
              inline={true}
              width={2}>
              <div
                style={{width: "100%"}}>
                {props.StartDate}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            inline={true}>
            <FormField
              inline={true}>
              <div
                style={{display: "flex", alignItems: "center", width: "200px"}}>
                
                <label
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "End date" : "วันที่สิ้นสุด"}
                </label>
                <label
                  style={{color: "red"}}>
                  *
                </label>
              </div>
            </FormField>
            <FormField
              className={!!props.showRequiredField?.end_date? "error" : ""}
              inline={true}
              width={2}>
              <div
                style={{width: "100%"}}>
                {props.EndDate}
              </div>
            </FormField>
            <FormField
              inline={true}
              width={4}>
              <div
                style={{display: "none", alignItems: "center", width: "100%", justifyContent: "flex-end"}}>
                
                <label
                  style={{fontWeight: "bold", marginRight: "1rem"}}>
                  {props.languageUX === "en" ? "IsActive" : "ใช้งานอยู่"}
                </label>
                <Checkbox
                  checked={props.packageDetail?.active || ""}
                  disabled={true}
                  name="active"
                  readOnly={true}
                  style={{transform: "scale(1.2)"}}>
                </Checkbox>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            inline={true}>
            <FormField
              inline={true}>
              <div
                style={{display: "grid", alignItems: "center", width: "200px"}}>
                
                <div
                  style={{display: "flex", marginRight: "5px"}}>
                  
                  <label
                    style={{fontWeight: "bold",}}>
                    {props.languageUX === "en" ? "Package pricing" : "ราคาแพ็คเกจ"}
                  </label>
                  <label
                    style={{color: "red"}}>
                    
                  </label>
                </div>
                <div>
                  
                  <label>
                    {props.languageUX === "en" ? "Selling price of this product" : "ราคาขายของสินค้านี้"}
                  </label>
                  <label
                    style={{color: "red"}}>
                    *
                  </label>
                </div>
              </div>
            </FormField>
            <FormField
              className={!!props.showRequiredField?.price_normal? "error" : ""}
              inline={true}
              width={2}>
              <Input
                disabled={props.isActive || false}
                fluid={true}
                id="CardSettingPackage-Input-Price-Normal"
                name="price_normal"
                onChange={props.onChangeValue}
                onKeyDown={(e: any)=> ["-","e"].includes(e.key) && e.preventDefault()}
                ref={props.inputRef}
                style={{width: "100%"}}
                type={props.isActive?"":"number"}
                value={props.packageDetail?.price_normal|| ""}>
              </Input>
            </FormField>
            <FormField>
              <label>
                {props.languageUX === "en" ? "baht" : "บาท"}
              </label>
            </FormField>
          </FormGroup>
          <FormGroup
            inline={true}>
            <FormField
              inline={true}>
              <div
                style={{display: "flex", alignItems: "center", width: "200px"}}>
                
                <label
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Package pricing (Premium)" : "ราคาแพ็กเกจ (พรีเมียม)"}
                </label>
                <label
                  style={{color: "red"}}>
                  *
                </label>
              </div>
            </FormField>
            <FormField
              className={!!props.showRequiredField?.price_normal? "error" : ""}
              inline={true}
              width={2}>
              <Input
                disabled={props.isActive || false}
                fluid={true}
                id="CardSettingPackage-Input-Price-Premium"
                name="price_premium"
                onChange={props.onChangeValue}
                onKeyDown={(e: any)=> ["-","e"].includes(e.key) && e.preventDefault()}
                ref={props.inputRef}
                style={{width: "100%"}}
                type={props.isActive?"":"number"}
                value={props.packageDetail?.price_premium|| ""}>
              </Input>
            </FormField>
            <FormField
              inline={true}>
              <label>
                {props.languageUX === "en" ? "baht" : "บาท"}
              </label>
            </FormField>
          </FormGroup>
          <FormGroup
            inline={true}>
            <FormField
              inline={true}>
              <div
                style={{display: "flex", alignItems: "center", width: "200px"}}>
                
                <label
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Package pricing (Foreign)" : "ราคาแพ็กเกจ (ต่างประเทศ)"}
                </label>
                <label
                  style={{color: "red"}}>
                  *
                </label>
              </div>
            </FormField>
            <FormField
              className={!!props.showRequiredField?.price_foreign? "error" : ""}
              inline={true}
              width={2}>
              <Input
                disabled={props.isActive || false}
                fluid={true}
                id="CardSettingPackage-Input-Price-Foreign"
                name="price_foreign"
                onChange={props.onChangeValue}
                onKeyDown={(e: any)=> ["-","e"].includes(e.key) && e.preventDefault()}
                ref={props.inputRef}
                style={{width: "100%"}}
                type={props.isActive?"":"number"}
                value={props.packageDetail?.price_foreign|| ""}>
              </Input>
            </FormField>
            <FormField
              inline={true}>
              <label>
                {props.languageUX === "en" ? "baht" : "บาท"}
              </label>
            </FormField>
          </FormGroup>
          <FormGroup
            inline={true}>
            <FormField
              inline={true}>
              <div
                style={{display: "flex", alignItems: "center", width: "200px"}}>
                
                <label
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Package type" : "ประเภทแพ็คเกจ"}
                </label>
                <label
                  style={{color: "red"}}>
                  *
                </label>
              </div>
            </FormField>
            <FormField
              className={!!props.showRequiredField?.usage_limit? "error" : ""}
              inline={true}
              width={2}>
              <Dropdown
                clearable={true}
                disabled={props.isActive || false}
                fluid={true}
                id="CardSettingPackage-Dropdown-UsageLimit"
                name="usage_limit"
                onChange={props.onChangeValue}
                options={props.usageLimitOptions || []}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.packageDetail?.usage_limit || ""}>
              </Dropdown>
            </FormField>
          </FormGroup>
        </div>
        <div
          style={{display: !props.hideDetail ?props.isNewProduct ? "none": "flex" : "none" , justifyContent: "flex-end", margin: "2rem 20px 1rem"}}>
          
          <Button
            disabled={props.disabledAddNewProduct || false}
            onClick={props.onAddNewProduct}
            style={{backgroundColor: "#5CD6F2", color: "white", display: "none"}}>
            <div
              style={{display: "flex", alignItems: "center"}}>
              
              <Icon
                name="plus">
              </Icon>
              <label>
                {props.languageUX === "en" ? "Add new item" : "เพิ่ม รายการใหม่"}
              </label>
            </div>
          </Button>
        </div>
        <div
          className="ui form"
          style={{padding: "0 20px", display: !props.hideDetail ? props.isNewProduct ? "": "none":"none"}}>
          
          <FormGroup
            inline={true}>
            <FormField>
              <label
                style={{color: "red"}}>
                {`ค้นหารายการสินค้าจาก ${props.tabName}`}
              </label>
            </FormField>
          </FormGroup>
          <FormGroup
            inline={true}
            style={{display: "none"}}>
            <FormField
              inline={true}>
              <label
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Product Code" : "รหัสสินค้า"}
              </label>
            </FormField>
            <FormField
              inline={true}
              width={7}>
              <div
                style={{width: "100%"}}>
                {props.SearchBoxPCode}
              </div>
            </FormField>
            <FormField
              inline={true}>
              <label
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Product Name" : "ชื่อสินค้า"}
              </label>
            </FormField>
            <FormField
              inline={true}
              width={7}>
              <div
                style={{width: "100%"}}>
                {props.SearchBoxPName}
              </div>
            </FormField>
            <FormField
              inline={true}>
              <Button
                color="green"
                onClick={props.onAddSuccess}
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "finish" : "เสร็จสิ้น"}
              </Button>
            </FormField>
          </FormGroup>
          <FormGroup
            inline={true}>
            <FormField
              style={{padding:0, marginTop: "-0.25rem"}}
              width={16}>
              <div
                style={{width: "100%"}}>
                {props.CardProductSearch}
              </div>
            </FormField>
          </FormGroup>
        </div>
        <div
          className="ui form"
          style={{padding: "0 20px", display: !props.hideDetail ? "":"none"}}>
          {props.TabPans}
        </div>
        <div
          className="ui form"
          style={{padding: "0 20px", display: !props.hideDetail ? "":"none"}}>
          {}
          <Table
            data={props.productItems || []}
            getTrProps={props.getTrProps}
            headers="ID,Product code,ชื่อสินค้า,QTY,หน่วยสั่ง,Price,Display,Delete"
            keys="product, product_code, product_name,quantity,unit_name,price, is_display,delete"
            minRows={5}
            showPagination={false}
            style={{height: "275px", marginTop: "1rem"}}
            widths="120,^90,^250,^70,^70,^80,^50,^50">
          </Table>
        </div>
        <div
          style={{ borderRadius: "5px", padding: "8px 0rem 8px 15px", margin: "1rem 20px 0rem", display: !props.hideDetail ? props.showPriceTotalProduct? "flex":"none":"none", justifyContent: "space-between", width: "calc(100vw - 28.5rem)"}}>
          
          <div
            style={{fontWeight: "bold", color: "#0072BC"}}>
            {`ราคาของ ${props.productType || ""} ทั้งหมด (บาท)`}
          </div>
          <div
            style={{width: "150px", display: "flex", justifyContent: "center"}}>
            
            <div
              style={{color: "#5A5A5A"}}>
              {props.priceTotalProduct || ""}
            </div>
          </div>
        </div>
        <div
          style={{background: "rgba(166, 238, 255, 0.32)", borderRadius: "5px", padding: "8px 0rem 8px 15px", margin: props.showPriceTotalProduct ?"0.5rem 20px 1.5rem":"2rem 20px 1.5rem", display: !props.hideDetail ? "flex":"none", justifyContent: "space-between", width: "calc(100vw - 28.5rem)"}}>
          
          <div
            style={{fontWeight: "bold", color: "#0072BC"}}>
            {props.languageUX === "en" ? "Price of all products in the package (baht)" : "ราคาของสินค้าทั้งหมดของแพ็กเกจ  (บาท)"}
          </div>
          <div
            style={{width: "150px", display: "flex", justifyContent: "center"}}>
            
            <div
              style={{color: "#5A5A5A"}}>
              {props.priceTotal || ""}
            </div>
          </div>
        </div>
        <div
          className="ui form"
          style={{display: !props.hideDetail ? "flex":"none", alignItems: "center", justifyContent: "flex-end", padding: "0 20px"}}>
          
          <div>
            {props.ButtonSave}
          </div>
          <div
            style={{display: !props.packageDetail?.id ? "none": ""}}>
            {props.ButtonActive}
          </div>
          <Button
            color="purple"
            onClick={props.onClickDuplicate}
            style={{display: !props.packageDetail?.id ? "none": ""}}>
            {props.languageUX === "en" ? "DUPLICATE" : "ทำซ้ำ"}
          </Button>
          <Button
            color="red"
            onClick={props.onClickCancel}>
            {props.languageUX === "en" ? "CANCEL" : "ยกเลิก"}
          </Button>
        </div>
      </div>
    )
}


export default CardSettingPackageUX

export const screenPropsDefault = {"current":null,"price_claimable":0,"price_non_claimable":0,"price_total":0}

/* Date Time : Mon Aug 18 2025 09:30:53 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", justifyContent: \"space-between\", padding: \"15px 10px\", backgroundColor: \"#A5D9FF\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "การตั้งค่ารายละเอียดแพ็กเกจ",
          "valueEN": "Package details settings"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.15rem\", fontWeight: \"bold\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: 0}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.SubSearchPackage"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "code",
          "value": "`ui form ${props.isActive  ? \"--override-disabled\": \"\"}`"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 20px\", display: !props.hideDetail ? \"\": \"none\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 6,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 6,
      "props": {
        "className": {
          "type": "code",
          "value": "!!props.showRequiredField?.code ? \"error\" : \"\""
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "Input",
      "parent": 8,
      "props": {
        "className": {
          "type": "code",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "props.isActive || false"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackage-Input-Code"
        },
        "name": {
          "type": "value",
          "value": "code"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "ref": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.code || \"\""
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"200px\"}"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "label",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัส",
          "valueEN": "Code"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"5px\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "label",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสแพ็กเกจ",
          "valueEN": "Package code"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "FormField",
      "parent": 16,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "FormField",
      "parent": 16,
      "props": {
        "className": {
          "type": "code",
          "value": "!!props.showRequiredField?.name ? \"error\" : \"\""
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "Input",
      "parent": 18,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.isActive || false"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackage-Input-PackageName"
        },
        "name": {
          "type": "value",
          "value": "name"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "ref": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.name|| \"\""
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 17,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"200px\"}"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "label",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อแพ็คเกจ",
          "valueEN": "Package name"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"5px\"}"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "label",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อแพ็กเกจ",
          "valueEN": "Package name"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "FormField",
      "parent": 23,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "FormField",
      "parent": 24,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "FormField",
      "parent": 25,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 26,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"200px\", marginTop: \"0.75rem\"}"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "div",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"200px\"}"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"200px\"}"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "label",
      "parent": 29,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทแพ็คเกจ",
          "valueEN": "Package type"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"5px\"}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "label",
      "parent": 29,
      "props": {
        "children": {
          "type": "value",
          "value": "ชนิดแพ็กเกจ",
          "valueEN": "Package Type"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "label",
      "parent": 30,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทบริการ",
          "valueEN": "Service type"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"5px\"}"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "label",
      "parent": 30,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทบริการ",
          "valueEN": "Service type"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "label",
      "parent": 31,
      "props": {
        "children": {
          "type": "value",
          "value": "เพศ:",
          "valueEN": "Gender:"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"5px\"}"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "FormField",
      "parent": 23,
      "props": {
        "className": {
          "type": "code",
          "value": "!!props.showRequiredField?.package_type ? \"error\" : \"\""
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",  alignItems: \"baseline\",}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "Dropdown",
      "parent": 38,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.isActive || false"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackage-Dropdown-PackageType"
        },
        "name": {
          "type": "value",
          "value": "package_type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.packageTypeOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.package_type || \"\""
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"fit-content\", display: \"flex\", margin: \"auto -7rem auto 1rem\",cursor: \"pointer\", pointerEvents: props.isActive? \"none\": \"\"}"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "Icon",
      "parent": 40,
      "props": {
        "className": {
          "type": "value",
          "value": "teal"
        },
        "link": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "plus"
        },
        "onClick": {
          "type": "code",
          "value": "()=> props.onOpenAdmin?.(\"PACKAGE_TYPE\")"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "FormField",
      "parent": 24,
      "props": {
        "className": {
          "type": "code",
          "value": "!!props.showRequiredField?.package_service_type ? \"error\" : \"\""
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{paddingRight: \"0.75em\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "div",
      "parent": 42,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",  alignItems: \"baseline\",width: \"100%\"}"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "Dropdown",
      "parent": 43,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.isActive || false"
        },
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackage-Dropdown-ServiceType"
        },
        "name": {
          "type": "value",
          "value": "package_service_type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.serviceTypeOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.package_service_type || \"\""
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "div",
      "parent": 43,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"fit-content\", display: \"flex\", margin: \"auto -7rem auto 1rem\",cursor: \"pointer\", pointerEvents: props.isActive? \"none\": \"\"}"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "Icon",
      "parent": 47,
      "props": {
        "className": {
          "type": "value",
          "value": "teal"
        },
        "link": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "plus"
        },
        "onClick": {
          "type": "code",
          "value": "()=> props.onOpenAdmin?.(\"SERVICE_TYPE\")"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "FormField",
      "parent": 25,
      "props": {
        "className": {
          "type": "code",
          "value": "!!props.showRequiredField?.gender ? \"error\" : \"\""
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "Dropdown",
      "parent": 49,
      "props": {
        "clearable": {
          "type": "code",
          "value": ""
        },
        "defaultValue": {
          "type": "value",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "props.isActive || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackage-Dropdown-Gender"
        },
        "name": {
          "type": "value",
          "value": "gender"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.genderOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.gender || \"\""
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "FormField",
      "parent": 51,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "FormField",
      "parent": 51,
      "props": {
        "className": {
          "type": "code",
          "value": ""
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "div",
      "parent": 52,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"200px\"}"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "label",
      "parent": 54,
      "props": {
        "children": {
          "type": "value",
          "value": "อายุเริ่มต้น",
          "valueEN": "Age start"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"5px\"}"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "label",
      "parent": 54,
      "props": {
        "children": {
          "type": "value",
          "value": "อายุ (ปี)",
          "valueEN": "Age (years)"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "Input",
      "parent": 53,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.isActive || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackage-Input-AgeStart"
        },
        "name": {
          "type": "value",
          "value": "age_limits_year_start"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any)=> [\"-\",\"e\"].includes(e.key) && e.preventDefault()"
        },
        "ref": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.age_limits_year_start ?? \"\""
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "FormField",
      "parent": 51,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "FormField",
      "parent": 51,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 60,
      "name": "div",
      "parent": 58,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", justifyContent: \"flex-end\", width: \"100%\"}"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "label",
      "parent": 60,
      "props": {
        "children": {
          "type": "value",
          "value": "สิ้นสุดอายุ",
          "valueEN": "Age end"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"5px\"}"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 62,
      "name": "label",
      "parent": 60,
      "props": {
        "children": {
          "type": "value",
          "value": "อายุ (ปี)",
          "valueEN": "Age (years)"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "Input",
      "parent": 59,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.isActive || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackage-Input-AgeEnd"
        },
        "name": {
          "type": "value",
          "value": "age_limits_year_end"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any)=> [\"-\",\"e\"].includes(e.key) && e.preventDefault()"
        },
        "ref": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.age_limits_year_end ?? \"\""
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "FormField",
      "parent": 64,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "FormField",
      "parent": 64,
      "props": {
        "className": {
          "type": "code",
          "value": "!!props.showRequiredField?.start_date? \"error\" : \"\""
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": null,
      "id": 69,
      "name": "div",
      "parent": 65,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"200px\"}"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "label",
      "parent": 69,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่เริ่มต้น",
          "valueEN": "Start date"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\",}"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "code",
          "value": "props.StartDate"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 73,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 74,
      "name": "FormField",
      "parent": 73,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 75,
      "name": "FormField",
      "parent": 73,
      "props": {
        "className": {
          "type": "code",
          "value": "!!props.showRequiredField?.end_date? \"error\" : \"\""
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": null,
      "id": 76,
      "name": "div",
      "parent": 74,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"200px\"}"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": null,
      "id": 77,
      "name": "label",
      "parent": 76,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่สิ้นสุด",
          "valueEN": "End date"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": null,
      "id": 78,
      "name": "div",
      "parent": 75,
      "props": {
        "children": {
          "type": "code",
          "value": "props.EndDate"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 79,
      "name": "FormField",
      "parent": 73,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "div",
      "parent": 79,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\", alignItems: \"center\", width: \"100%\", justifyContent: \"flex-end\"}"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": null,
      "id": 81,
      "name": "label",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": "ใช้งานอยู่",
          "valueEN": "IsActive"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"1rem\"}"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 82,
      "name": "Checkbox",
      "parent": 80,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.packageDetail?.active || \"\""
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "active"
        },
        "onChange": {
          "type": "code",
          "value": ""
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{transform: \"scale(1.2)\"}"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 83,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 84,
      "name": "FormField",
      "parent": 83,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 85,
      "name": "FormField",
      "parent": 83,
      "props": {
        "className": {
          "type": "code",
          "value": "!!props.showRequiredField?.price_normal? \"error\" : \"\""
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": null,
      "id": 86,
      "name": "div",
      "parent": 84,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"grid\", alignItems: \"center\", width: \"200px\"}"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 89,
      "name": "Input",
      "parent": 85,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.isActive || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackage-Input-Price-Normal"
        },
        "name": {
          "type": "value",
          "value": "price_normal"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any)=> [\"-\",\"e\"].includes(e.key) && e.preventDefault()"
        },
        "ref": {
          "type": "code",
          "value": "props.inputRef"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "type": {
          "type": "code",
          "value": "props.isActive?\"\":\"number\""
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.price_normal|| \"\""
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 90,
      "name": "FormField",
      "parent": 83,
      "props": {
      },
      "seq": 90,
      "void": false
    },
    {
      "from": null,
      "id": 91,
      "name": "label",
      "parent": 90,
      "props": {
        "children": {
          "type": "value",
          "value": "บาท",
          "valueEN": "baht"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: !props.hideDetail ?props.isNewProduct ? \"none\": \"flex\" : \"none\" , justifyContent: \"flex-end\", margin: \"2rem 20px 1rem\"}"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 93,
      "name": "Button",
      "parent": 92,
      "props": {
        "color": {
          "type": "value",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledAddNewProduct || false"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddNewProduct"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"#5CD6F2\", color: \"white\", display: \"none\"}"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "div",
      "parent": 93,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 95,
      "name": "Icon",
      "parent": 94,
      "props": {
        "name": {
          "type": "value",
          "value": "plus"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "label",
      "parent": 94,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่ม รายการใหม่",
          "valueEN": "Add new item"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": null,
      "id": 98,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 20px\", display: !props.hideDetail ? \"\":\"none\"}"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": null,
      "id": 99,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.TabPans"
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 20px\", display: !props.hideDetail ? \"\":\"none\"}"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 100,
      "name": "Table",
      "parent": 98,
      "props": {
        "data": {
          "type": "code",
          "value": "props.productItems || []"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.getTrProps"
        },
        "headers": {
          "type": "value",
          "value": "ID,Product code,ชื่อสินค้า,QTY,หน่วยสั่ง,Price,Display,Delete"
        },
        "keys": {
          "type": "value",
          "value": "product, product_code, product_name,quantity,unit_name,price, is_display,delete"
        },
        "minRows": {
          "type": "code",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"275px\", marginTop: \"1rem\"}"
        },
        "widths": {
          "type": "value",
          "value": "120,^90,^250,^70,^70,^80,^50,^50"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": null,
      "id": 101,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{background: \"rgba(166, 238, 255, 0.32)\", borderRadius: \"5px\", padding: \"8px 0rem 8px 15px\", margin: props.showPriceTotalProduct ?\"0.5rem 20px 1.5rem\":\"2rem 20px 1.5rem\", display: !props.hideDetail ? \"flex\":\"none\", justifyContent: \"space-between\", width: \"calc(100vw - 28.5rem)\"}"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": null,
      "id": 102,
      "name": "div",
      "parent": 101,
      "props": {
        "children": {
          "type": "value",
          "value": "ราคาของสินค้าทั้งหมดของแพ็กเกจ  (บาท)",
          "valueEN": "Price of all products in the package (baht)"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", color: \"#0072BC\"}"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": null,
      "id": 103,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "style": {
          "type": "code",
          "value": "{display: !props.hideDetail ? \"flex\":\"none\", alignItems: \"center\", justifyContent: \"flex-end\", padding: \"0 20px\"}"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 107,
      "name": "Button",
      "parent": 103,
      "props": {
        "children": {
          "type": "value",
          "value": "ทำซ้ำ",
          "valueEN": "DUPLICATE"
        },
        "color": {
          "type": "value",
          "value": "purple"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickDuplicate"
        },
        "style": {
          "type": "code",
          "value": "{display: !props.packageDetail?.id ? \"none\": \"\"}"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": null,
      "id": 108,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 20px\", display: !props.hideDetail ? props.isNewProduct ? \"\": \"none\":\"none\"}"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 109,
      "name": "FormGroup",
      "parent": 108,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 110,
      "name": "FormGroup",
      "parent": 108,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\"}"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 111,
      "name": "FormField",
      "parent": 109,
      "props": {
      },
      "seq": 111,
      "void": false
    },
    {
      "from": null,
      "id": 112,
      "name": "label",
      "parent": 111,
      "props": {
        "children": {
          "type": "code",
          "value": "`ค้นหารายการสินค้าจาก ${props.tabName}`"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 113,
      "name": "FormField",
      "parent": 110,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 114,
      "name": "FormField",
      "parent": 110,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 115,
      "name": "FormField",
      "parent": 110,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 116,
      "name": "FormField",
      "parent": 110,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 117,
      "name": "FormField",
      "parent": 110,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": null,
      "id": 118,
      "name": "label",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสสินค้า",
          "valueEN": "Product Code"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": null,
      "id": 119,
      "name": "label",
      "parent": 115,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อสินค้า",
          "valueEN": "Product Name"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": null,
      "id": 120,
      "name": "div",
      "parent": 114,
      "props": {
        "children": {
          "type": "code",
          "value": "props.SearchBoxPName"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": null,
      "id": 121,
      "name": "div",
      "parent": 116,
      "props": {
        "children": {
          "type": "code",
          "value": "props.SearchBoxPCode"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 122,
      "name": "Button",
      "parent": 117,
      "props": {
        "children": {
          "type": "value",
          "value": "เสร็จสิ้น",
          "valueEN": "finish"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddSuccess"
        },
        "size": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": null,
      "id": 124,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ borderRadius: \"5px\", padding: \"8px 0rem 8px 15px\", margin: \"1rem 20px 0rem\", display: !props.hideDetail ? props.showPriceTotalProduct? \"flex\":\"none\":\"none\", justifyContent: \"space-between\", width: \"calc(100vw - 28.5rem)\"}"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 125,
      "name": "div",
      "parent": 124,
      "props": {
        "children": {
          "type": "code",
          "value": "`ราคาของ ${props.productType || \"\"} ทั้งหมด (บาท)`"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", color: \"#0072BC\"}"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": null,
      "id": 127,
      "name": "div",
      "parent": 103,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonSave"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": null,
      "id": 128,
      "name": "div",
      "parent": 103,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonActive"
        },
        "style": {
          "type": "code",
          "value": "{display: !props.packageDetail?.id ? \"none\": \"\"}"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": null,
      "id": 129,
      "name": "div",
      "parent": 124,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"150px\", display: \"flex\", justifyContent: \"center\"}"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": null,
      "id": 130,
      "name": "div",
      "parent": 101,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"150px\", display: \"flex\", justifyContent: \"center\"}"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": null,
      "id": 131,
      "name": "div",
      "parent": 129,
      "props": {
        "children": {
          "type": "code",
          "value": "props.priceTotalProduct || \"\""
        },
        "style": {
          "type": "code",
          "value": "{color: \"#5A5A5A\"}"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": null,
      "id": 132,
      "name": "div",
      "parent": 130,
      "props": {
        "children": {
          "type": "code",
          "value": "props.priceTotal || \"\""
        },
        "style": {
          "type": "code",
          "value": "{color: \"#5A5A5A\"}"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": null,
      "id": 134,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "code",
          "value": "props.PackageRefreshIcon"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"0.75rem\"}"
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": null,
      "id": 136,
      "name": "div",
      "parent": 47,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ServiceRefreshIcon"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"0.75rem\"}"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 137,
      "name": "FormField",
      "parent": 51,
      "props": {
        "style": {
          "type": "code",
          "value": "{display: props.showAgeError ? \"\": \"none\"}"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": null,
      "id": 138,
      "name": "label",
      "parent": 137,
      "props": {
        "children": {
          "type": "value",
          "value": "Age end ต้องไม่น้อยกว่า Age start",
          "valueEN": "Age end must not be less than Age start"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\", fontWeight: \"normal\"}"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 139,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 140,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 141,
      "name": "FormField",
      "parent": 139,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 142,
      "name": "FormField",
      "parent": 139,
      "props": {
        "className": {
          "type": "code",
          "value": "!!props.showRequiredField?.price_normal? \"error\" : \"\""
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 143,
      "name": "FormField",
      "parent": 140,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 144,
      "name": "FormField",
      "parent": 140,
      "props": {
        "className": {
          "type": "code",
          "value": "!!props.showRequiredField?.price_foreign? \"error\" : \"\""
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 145,
      "name": "FormField",
      "parent": 140,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 146,
      "name": "FormField",
      "parent": 139,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 149,
      "name": "Input",
      "parent": 142,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.isActive || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackage-Input-Price-Premium"
        },
        "name": {
          "type": "value",
          "value": "price_premium"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any)=> [\"-\",\"e\"].includes(e.key) && e.preventDefault()"
        },
        "ref": {
          "type": "code",
          "value": "props.inputRef"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "type": {
          "type": "code",
          "value": "props.isActive?\"\":\"number\""
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.price_premium|| \"\""
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 150,
      "name": "Input",
      "parent": 144,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.isActive || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackage-Input-Price-Foreign"
        },
        "name": {
          "type": "value",
          "value": "price_foreign"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any)=> [\"-\",\"e\"].includes(e.key) && e.preventDefault()"
        },
        "ref": {
          "type": "code",
          "value": "props.inputRef"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "type": {
          "type": "code",
          "value": "props.isActive?\"\":\"number\""
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.price_foreign|| \"\""
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": null,
      "id": 151,
      "name": "label",
      "parent": 146,
      "props": {
        "children": {
          "type": "value",
          "value": "บาท",
          "valueEN": "baht"
        }
      },
      "seq": 151,
      "void": false
    },
    {
      "from": null,
      "id": 152,
      "name": "label",
      "parent": 145,
      "props": {
        "children": {
          "type": "value",
          "value": "บาท",
          "valueEN": "baht"
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": null,
      "id": 153,
      "name": "div",
      "parent": 141,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"200px\"}"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": null,
      "id": 154,
      "name": "div",
      "parent": 143,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"200px\"}"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": null,
      "id": 155,
      "name": "label",
      "parent": 153,
      "props": {
        "children": {
          "type": "value",
          "value": "ราคาแพ็กเกจ (พรีเมียม)",
          "valueEN": "Package pricing (Premium)"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": null,
      "id": 156,
      "name": "label",
      "parent": 154,
      "props": {
        "children": {
          "type": "value",
          "value": "ราคาแพ็กเกจ (ต่างประเทศ)",
          "valueEN": "Package pricing (Foreign)"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 157,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 164,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 158,
      "name": "FormField",
      "parent": 157,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 159,
      "name": "FormField",
      "parent": 157,
      "props": {
        "className": {
          "type": "code",
          "value": "!!props.showRequiredField?.usage_limit? \"error\" : \"\""
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": null,
      "id": 161,
      "name": "div",
      "parent": 158,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"200px\"}"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 162,
      "name": "Dropdown",
      "parent": 159,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.isActive || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackage-Dropdown-UsageLimit"
        },
        "name": {
          "type": "value",
          "value": "usage_limit"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.usageLimitOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.usage_limit || \"\""
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": null,
      "id": 163,
      "name": "label",
      "parent": 161,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทแพ็คเกจ",
          "valueEN": "Package type"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 163,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 164,
      "name": "FormGroup",
      "parent": 5,
      "props": {
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 165,
      "name": "FormField",
      "parent": 164,
      "props": {
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.2rem\", borderBottom: \"1px solid rgba(34,36,38,.15)\", padding: \"0px 0px 0.55rem 0.5rem\"}"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": null,
      "id": 166,
      "name": "div",
      "parent": 165,
      "props": {
        "children": {
          "type": "code",
          "value": "props.packageDetail?.id?`${props.packageDetail?.code} : ${props.packageDetail?.name}`:\"เพิ่มรายการใหม่\""
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 167,
      "name": "Button",
      "parent": 103,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิก",
          "valueEN": "CANCEL"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickCancel"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": null,
      "id": 168,
      "name": "label",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": null,
      "id": 169,
      "name": "label",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 169,
      "void": false
    },
    {
      "from": null,
      "id": 170,
      "name": "label",
      "parent": 29,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 170,
      "void": false
    },
    {
      "from": null,
      "id": 171,
      "name": "label",
      "parent": 30,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": null,
      "id": 172,
      "name": "label",
      "parent": 54,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": null,
      "id": 173,
      "name": "label",
      "parent": 69,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 173,
      "void": false
    },
    {
      "from": null,
      "id": 174,
      "name": "label",
      "parent": 76,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 174,
      "void": false
    },
    {
      "from": null,
      "id": 175,
      "name": "div",
      "parent": 86,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", marginRight: \"5px\"}"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 176,
      "name": "label",
      "parent": 175,
      "props": {
        "children": {
          "type": "value",
          "value": "ราคาแพ็คเกจ",
          "valueEN": "Package pricing"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\",}"
        }
      },
      "seq": 176,
      "void": false
    },
    {
      "from": null,
      "id": 177,
      "name": "label",
      "parent": 175,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 177,
      "void": false
    },
    {
      "from": null,
      "id": 178,
      "name": "label",
      "parent": 153,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": null,
      "id": 179,
      "name": "label",
      "parent": 154,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 179,
      "void": false
    },
    {
      "from": null,
      "id": 180,
      "name": "label",
      "parent": 161,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 180,
      "void": false
    },
    {
      "from": null,
      "id": 181,
      "name": "div",
      "parent": 86,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 181,
      "void": false
    },
    {
      "from": null,
      "id": 182,
      "name": "label",
      "parent": 181,
      "props": {
        "children": {
          "type": "value",
          "value": "ราคาขายของสินค้านี้",
          "valueEN": "Selling price of this product"
        }
      },
      "seq": 182,
      "void": false
    },
    {
      "from": null,
      "id": 183,
      "name": "label",
      "parent": 181,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 183,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 184,
      "name": "FormField",
      "parent": 6,
      "props": {
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 184,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 185,
      "name": "FormField",
      "parent": 6,
      "props": {
      },
      "seq": 185,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 186,
      "name": "Label",
      "parent": 185,
      "props": {
        "children": {
          "type": "code",
          "value": "props.labelActive?.text"
        },
        "color": {
          "type": "code",
          "value": "props.labelActive?.color"
        },
        "style": {
          "type": "code",
          "value": "{display: props.labelActive?.text?\"\":\"none\", width: \"100px\", textAlign: \"center\"}"
        }
      },
      "seq": 186,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 187,
      "name": "FormGroup",
      "parent": 108,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 187,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 188,
      "name": "FormField",
      "parent": 187,
      "props": {
        "style": {
          "type": "code",
          "value": "{padding:0, marginTop: \"-0.25rem\"}"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 188,
      "void": false
    },
    {
      "from": null,
      "id": 189,
      "name": "div",
      "parent": 188,
      "props": {
        "children": {
          "type": "code",
          "value": "props.CardProductSearch"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 189,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 95,
  "isMounted": false,
  "memo": false,
  "name": "CardSettingPackageUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "current": null,
    "price_claimable": 0,
    "price_non_claimable": 0,
    "price_total": 0
  },
  "width": 55
}

*********************************************************************************** */
